import { useState, useCallback } from 'react';
import { API_URL, useAuth } from '../context/AuthContext';
import { warehouseWrites } from '../updates/activity';
interface UseApiReturn { fetchApi: <T = unknown>(path: string, options?: RequestInit) => Promise<T | null>; loading: boolean; error: string | null }
export function useApi(): UseApiReturn {
  const { currentShop, refresh } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const fetchApi = useCallback(async <T = unknown>(path: string, options: RequestInit = {}): Promise<T | null> => {
    setLoading(true); setError(null);
    const endWrite = ['GET', 'HEAD'].includes((options.method || 'GET').toUpperCase()) ? () => {} : warehouseWrites.begin();
    try {
      if (!currentShop) throw new Error('Choose a warehouse account first');
      const headers = new Headers(options.headers);
      headers.set('Content-Type', 'application/json'); headers.set('X-Shop-Domain', currentShop.domain);
      if (currentShop.organizationId) headers.set('X-Organization-Id', currentShop.organizationId);
      const request = () => fetch(`${API_URL}/api${path}`, { ...options, headers, credentials: 'include' });
      let response = await request();
      if (response.status === 401 && await refresh()) response = await request();
      const data = await response.json();
      if (!response.ok || data.success === false) throw new Error(data.error || `Request failed (${response.status})`);
      return data as T;
    } catch (err) { setError(err instanceof Error ? err.message : 'Request failed'); return null; }
    finally { endWrite(); setLoading(false); }
  }, [currentShop?.domain, currentShop?.organizationId, refresh]);
  return { fetchApi, loading, error };
}
